export default __webpack_public_path__ + "52599718238d27aa770ab027fb02c290.png";